import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const StencilApproxSize = (props) => {
  const name = 'stencil_size';

  const {
    label,
    inputId,
    required,
    groupName,
    children,
    onChangeParameter,
    errorMessage,
    tooltip,
    parameters,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      value={parameters[name] || ''}
      required={required}
      onChange={onChange}
      tooltip={tooltip}
      ignoreOnQuote
      groupName={groupName}
      errorMessage={errorMessage}>
      {children}
    </TextComponent>
  );
};

StencilApproxSize.defaultProps = {
  required: true,
  inputId: 'stencil-approx-size',
  label: Spree.translations.parameters.stencil_size,
  tooltip: Spree.helpForParameters.stencil_size,
};

export default StencilApproxSize;
